"use strict";

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderSingleInputValue = exports.renderMultiInputValue = exports.haveSameKeys = exports.getSelectedOptions = exports.getSelectedOption = exports.getOptionsList = exports.NO_GROUP_HEADER = exports.MRU_GROUP_KEY = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _listboxUtils = require("../List/_listboxUtils");
var _isFunction = require("./isFunction");
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var NO_GROUP_HEADER = exports.NO_GROUP_HEADER = '__NoGroupHeader__';
var MRU_GROUP_KEY = exports.MRU_GROUP_KEY = '__mruGroup__';
var getOptionsList = exports.getOptionsList = function getOptionsList(_ref) {
  var _context;
  var options = _ref.options,
    mruOptions = _ref.mruOptions,
    groupBy = _ref.groupBy,
    mruTitle = _ref.mruTitle,
    otherGroupHeader = _ref.otherGroupHeader;
  var newMruOptions = mruOptions === null || mruOptions === void 0 ? void 0 : (0, _map.default)(mruOptions).call(mruOptions, function (option) {
    return _objectSpread(_objectSpread({}, option), {}, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, groupBy !== null && groupBy !== void 0 && groupBy.length ? groupBy : MRU_GROUP_KEY, mruTitle), "isMru", true));
  });

  // put all options into a map with group as key
  var uniqueGroups = {};
  options === null || options === void 0 || options.forEach(function (eachOption) {
    var groupLabel = eachOption[groupBy] || otherGroupHeader || NO_GROUP_HEADER;
    if (!uniqueGroups[groupLabel]) {
      uniqueGroups[groupLabel] = [];
    }
    uniqueGroups[groupLabel].push(eachOption);
  });
  var newOptions = [];
  if (newMruOptions !== null && newMruOptions !== void 0 && newMruOptions.length) {
    var mruOptionsGroup = (0, _toConsumableArray2.default)(newMruOptions);
    if (options !== null && options !== void 0 && options.length) {
      mruOptionsGroup.push({
        divider: true
      });
    }
    newOptions.push(mruOptionsGroup);
  }
  (0, _sort.default)(_context = (0, _keys.default)(uniqueGroups)).call(_context, function (groupHeader) {
    return groupHeader === NO_GROUP_HEADER ? -1 : 0;
  }).forEach(function (groupKey, index) {
    var groupToPush = (0, _toConsumableArray2.default)(uniqueGroups[groupKey]);
    if (index < uniqueGroups.length - 1) {
      groupToPush.push({
        divider: true
      });
    }
    newOptions.push(groupToPush);
  });

  // one last sanity check
  // grouped list if:
  //   - `groupBy` is set
  //   - `otherGroupHeader` is set
  //   - `mruOptions` is set and not empty
  var isUsingGroups = !!groupBy || !!otherGroupHeader || (newMruOptions === null || newMruOptions === void 0 ? void 0 : newMruOptions.length) > 0;
  var groupLabelRenderer = function groupLabelRenderer(groupData) {
    var _groupData$3;
    if (groupBy !== null && groupBy !== void 0 && groupBy.length) {
      var _groupData$;
      if ((_groupData$ = groupData[0]) !== null && _groupData$ !== void 0 && _groupData$[groupBy]) {
        var _groupData$2;
        return (_groupData$2 = groupData[0]) === null || _groupData$2 === void 0 ? void 0 : _groupData$2[groupBy];
      }
    }
    if ((_groupData$3 = groupData[0]) !== null && _groupData$3 !== void 0 && _groupData$3[MRU_GROUP_KEY]) {
      return mruTitle;
    }
    if (otherGroupHeader) {
      return otherGroupHeader;
    }
    return null;
  };
  return {
    newOptions: newOptions,
    isUsingGroups: isUsingGroups,
    groupLabelRenderer: groupLabelRenderer
  };
};
var getSelectedOption = exports.getSelectedOption = function getSelectedOption(options, itemKey, selectedOptionKey) {
  return (0, _find.default)(options).call(options, function (option) {
    return "".concat((0, _listboxUtils.reduceOption)(option, itemKey)) === selectedOptionKey;
  });
};
var getSelectedOptions = exports.getSelectedOptions = function getSelectedOptions(options, itemKey) {
  var selectedOptionKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return (0, _map.default)(selectedOptionKeys).call(selectedOptionKeys, function (key) {
    return (0, _find.default)(options).call(options, function (option) {
      return "".concat((0, _listboxUtils.reduceOption)(option, itemKey)) === key;
    });
  });
};
var renderSingleInputValue = exports.renderSingleInputValue = function renderSingleInputValue(_ref2) {
  var options = _ref2.options,
    itemKey = _ref2.itemKey,
    inputRenderer = _ref2.inputRenderer,
    selectedOptionKey = _ref2.selectedOptionKey;
  var someOption = getSelectedOption(options, itemKey, selectedOptionKey);
  if ((0, _isFunction.isFunction)(inputRenderer)) {
    return inputRenderer(someOption, selectedOptionKey);
  }
  return (someOption === null || someOption === void 0 ? void 0 : someOption[inputRenderer]) || '';
};
var renderMultiInputValue = exports.renderMultiInputValue = function renderMultiInputValue(_ref3) {
  var options = _ref3.options,
    itemKey = _ref3.itemKey,
    inputRenderer = _ref3.inputRenderer,
    selectedOptionKeys = _ref3.selectedOptionKeys;
  var someOptions = getSelectedOptions(options, itemKey, selectedOptionKeys);
  var renderedValues = [];
  if ((0, _isFunction.isFunction)(inputRenderer)) {
    return inputRenderer(someOptions, selectedOptionKeys);
  }
  renderedValues = (0, _map.default)(someOptions).call(someOptions, function (someOption) {
    return (someOption === null || someOption === void 0 ? void 0 : someOption[inputRenderer]) || '';
  });
  return renderedValues.join(', ');
};

// check if two arrays have the same values
var haveSameKeys = exports.haveSameKeys = function haveSameKeys() {
  var _context2, _context3;
  var keys1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keys2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (keys1.length !== keys2.length) return false;
  var _ref4 = [(0, _sort.default)(_context2 = (0, _slice.default)(keys1).call(keys1)).call(_context2), (0, _sort.default)(_context3 = (0, _slice.default)(keys2).call(keys2)).call(_context3)],
    sortedKeys1 = _ref4[0],
    sortedKeys2 = _ref4[1];
  return sortedKeys1.every(function (val, index) {
    return val === sortedKeys2[index];
  });
};